import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export const WishlistApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({

    getWishlist: builder.query<ResultsDTO, { page?: number; productsCount?: number } | void>({
      query: (arg) => {
        const { page = 1, productsCount = 100 } = arg || {};
        return {
          url: `/wishlist/`,
          method: "GET",
          params: { page, productsCount },
          headers: { origin: window.location.origin },
        };
      },
      providesTags: ["Wishlist"],
    }),

    addToWishlist: builder.mutation<ResultsDTO, string>({
      query: (item: string) => ({
        url: `/wishlist/save`,
        method: "POST",
        body: {
          item: String(item),
        },
        headers: { origin: window.location.origin },
      }),
      invalidatesTags: ["Wishlist"],
    }),

    removeFromWishlist: builder.mutation<ResultsDTO, string>({
      query: (item: string) => ({
        url: `/wishlist/remove`,
        method: "DELETE",
        params: {
          item: String(item),
        },
        headers: { origin: window.location.origin },
      }),
      invalidatesTags: ["Wishlist"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetWishlistQuery,
  useAddToWishlistMutation,
  useRemoveFromWishlistMutation,
} = WishlistApiSlice;
